<div class="app_container">
  <router-outlet></router-outlet>
</div>